import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const AustraliaPage = () => {
  return <DestinationTemplate destinationId="australia" />;
};

export default AustraliaPage;
